var render = function render(){var _vm=this,_c=_vm._self._c;return _c('beast-packages-list',{attrs:{"url":_vm.packageUrl,"package-search":false},on:{"keywordSearch":_vm.updateSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }